module.exports = __webpack_public_path__ + "files/e0ac903d378f5054f31fd391288c1493.png";